// Sdileny vypocet poctu sloupcu gridu dlazdic (next/ obrazovky) - drive
// nezavisle implementovany (stejny algoritmus, jina cisla) v CityNext.vue,
// WildNext.vue a StartingNext.vue. Zkousi od minCols nahoru, prvni pocet
// sloupcu, kam se vsechny radky vejdou na vysku bez scrollovani, vyhrava.
//
// - CityNext.vue/WildNext.vue: rowGap=10, nameRowH=0 (dlazdice je ctverec
//   bez extra radku na jmeno), extraHeight = bannerHeight + TEAM_SHEET_HANDLE_HEIGHT.
// - StartingNext.vue: rowGap=14, nameRowH=32 (jmeno pod dlazdici),
//   extraHeight = titleRowHeight.
export function computeGridCols({
    n,
    containerWidth,
    containerHeight,
    extraHeight = 0,
    rowGap,
    nameRowH = 0,
    colHPadding = 8,
    rowHPadding = 16,
    bottomMargin = 20,
    minCols = 2,
    maxCols = 4,
    fallback = 4,
}) {
    if (!n || !containerWidth || !containerHeight) {
        return fallback;
    }
    const availableHeight = containerHeight - extraHeight - bottomMargin;
    const availableWidth = containerWidth - rowHPadding;
    for (let c = minCols; c <= maxCols; c++) {
        const tileWidth = availableWidth / c - colHPadding;
        const rowHeight = tileWidth + nameRowH;
        const rows = Math.ceil(n / c);
        const totalHeight = rows * rowHeight + (rows - 1) * rowGap;
        if (totalHeight <= availableHeight) {
            return c;
        }
    }
    return fallback;
}
